export var viewProfile = {
    "startIndex": 0,
    "noOfRowsToFetch": 0,
    "mapOfAdditinalParams": null,
    "createdBy": null,
    "createdOn": 1478284428000,
    "lastUpdatedBy": "ANONYMOUS",
    "lastUpdatedOn": 1478284525000,
    "expiryOn": null,
    "createdOnDateForDisplay": "11/04/2016",
    "createdOnDateInDDMmYYYFormat": null,
    "formattedCreatedDateForDisplay": null,
    "formattedUpdatedDateForDisplay": null,
    "userDetailsId": 42,
    "firstName": "Fast",
    "middleName": null,
    "lastName": "SSD",
    "emailId": "fastssd27@uvsity.com",
    "gender": "M",
    "profilepicName": null,
    "aboutMe": null,
    "myInterests": null,
    "termsConditions": null,
    "phoneMobile": null,
    "phoneWork": null,
    "phoneHome": null,
    "accountActive": "T",
    "professorConnectionCount": null,
    "studentConnectionCount": null,
    "alumniConnectionCount": null,
    "noOfNewMessages": null,
    "noOfDeletedMessages": null,
    "noOfConnections": null,
    "noOfRecommendationsReceived": null,
    "noOfNewRecommendationsReceived": null,
    "noOfAcceptedRecommendations": null,
    "noOfNewRecommendationRequestsReceived": null,
    "noOfNewRatingRequestsReceived": null,
    "noOfNewInvitationsReceived": null,
    "noOfRatingStars": null,
    "starCount": null,
    "membershipStartDate": null,
    "membershipEndDate": null,
    "payPalId": null,
    "autoApproveCourseInd": null,
    "isRegistrationStepTwoComplete": "T",
    "ratingAction": null,
    "userType": {
        "startIndex": 0,
        "noOfRowsToFetch": 0,
        "mapOfAdditinalParams": null,
        "createdBy": null,
        "createdOn": null,
        "lastUpdatedBy": null,
        "lastUpdatedOn": null,
        "expiryOn": null,
        "createdOnDateForDisplay": null,
        "createdOnDateInDDMmYYYFormat": null,
        "formattedCreatedDateForDisplay": null,
        "formattedUpdatedDateForDisplay": null,
        "userTypeId": 14,
        "userTypeCode": "PR",
        "userTypeFullDescription": "Professor",
        "userSubTypes": [
            {
                "startIndex": 0,
                "noOfRowsToFetch": 0,
                "mapOfAdditinalParams": null,
                "createdBy": "NULL",
                "createdOn": null,
                "lastUpdatedBy": "NULL",
                "lastUpdatedOn": null,
                "expiryOn": null,
                "createdOnDateForDisplay": null,
                "createdOnDateInDDMmYYYFormat": null,
                "formattedCreatedDateForDisplay": null,
                "formattedUpdatedDateForDisplay": null,
                "userSubTypeMasterId": 1,
                "userSubTypeMaster": "Adjunct Professor"
            },
            {
                "startIndex": 0,
                "noOfRowsToFetch": 0,
                "mapOfAdditinalParams": null,
                "createdBy": "NULL",
                "createdOn": null,
                "lastUpdatedBy": "NULL",
                "lastUpdatedOn": null,
                "expiryOn": null,
                "createdOnDateForDisplay": null,
                "createdOnDateInDDMmYYYFormat": null,
                "formattedCreatedDateForDisplay": null,
                "formattedUpdatedDateForDisplay": null,
                "userSubTypeMasterId": 1,
                "userSubTypeMaster": "Adjunct Professor"
            },
            {
                "startIndex": 0,
                "noOfRowsToFetch": 0,
                "mapOfAdditinalParams": null,
                "createdBy": "NULL",
                "createdOn": null,
                "lastUpdatedBy": "NULL",
                "lastUpdatedOn": null,
                "expiryOn": null,
                "createdOnDateForDisplay": null,
                "createdOnDateInDDMmYYYFormat": null,
                "formattedCreatedDateForDisplay": null,
                "formattedUpdatedDateForDisplay": null,
                "userSubTypeMasterId": 2,
                "userSubTypeMaster": "Adjunct Associate"
            },
            {
                "startIndex": 0,
                "noOfRowsToFetch": 0,
                "mapOfAdditinalParams": null,
                "createdBy": "NULL",
                "createdOn": null,
                "lastUpdatedBy": "NULL",
                "lastUpdatedOn": null,
                "expiryOn": null,
                "createdOnDateForDisplay": null,
                "createdOnDateInDDMmYYYFormat": null,
                "formattedCreatedDateForDisplay": null,
                "formattedUpdatedDateForDisplay": null,
                "userSubTypeMasterId": 3,
                "userSubTypeMaster": "Professor"
            },
            {
                "startIndex": 0,
                "noOfRowsToFetch": 0,
                "mapOfAdditinalParams": null,
                "createdBy": "NULL",
                "createdOn": null,
                "lastUpdatedBy": "NULL",
                "lastUpdatedOn": null,
                "expiryOn": null,
                "createdOnDateForDisplay": null,
                "createdOnDateInDDMmYYYFormat": null,
                "formattedCreatedDateForDisplay": null,
                "formattedUpdatedDateForDisplay": null,
                "userSubTypeMasterId": 4,
                "userSubTypeMaster": "Adjunct Assistant Professor"
            },
            {
                "startIndex": 0,
                "noOfRowsToFetch": 0,
                "mapOfAdditinalParams": null,
                "createdBy": "NULL",
                "createdOn": null,
                "lastUpdatedBy": "NULL",
                "lastUpdatedOn": null,
                "expiryOn": null,
                "createdOnDateForDisplay": null,
                "createdOnDateInDDMmYYYFormat": null,
                "formattedCreatedDateForDisplay": null,
                "formattedUpdatedDateForDisplay": null,
                "userSubTypeMasterId": 5,
                "userSubTypeMaster": "Visiting Professor"
            },
            {
                "startIndex": 0,
                "noOfRowsToFetch": 0,
                "mapOfAdditinalParams": null,
                "createdBy": "NULL",
                "createdOn": null,
                "lastUpdatedBy": "NULL",
                "lastUpdatedOn": null,
                "expiryOn": null,
                "createdOnDateForDisplay": null,
                "createdOnDateInDDMmYYYFormat": null,
                "formattedCreatedDateForDisplay": null,
                "formattedUpdatedDateForDisplay": null,
                "userSubTypeMasterId": 6,
                "userSubTypeMaster": "Visiting Associate Professor"
            },
            {
                "startIndex": 0,
                "noOfRowsToFetch": 0,
                "mapOfAdditinalParams": null,
                "createdBy": "NULL",
                "createdOn": null,
                "lastUpdatedBy": "NULL",
                "lastUpdatedOn": null,
                "expiryOn": null,
                "createdOnDateForDisplay": null,
                "createdOnDateInDDMmYYYFormat": null,
                "formattedCreatedDateForDisplay": null,
                "formattedUpdatedDateForDisplay": null,
                "userSubTypeMasterId": 7,
                "userSubTypeMaster": "Visiting Assistant Professor"
            },
            {
                "startIndex": 0,
                "noOfRowsToFetch": 0,
                "mapOfAdditinalParams": null,
                "createdBy": "NULL",
                "createdOn": null,
                "lastUpdatedBy": "NULL",
                "lastUpdatedOn": null,
                "expiryOn": null,
                "createdOnDateForDisplay": null,
                "createdOnDateInDDMmYYYFormat": null,
                "formattedCreatedDateForDisplay": null,
                "formattedUpdatedDateForDisplay": null,
                "userSubTypeMasterId": 8,
                "userSubTypeMaster": "Research Professor"
            },
            {
                "startIndex": 0,
                "noOfRowsToFetch": 0,
                "mapOfAdditinalParams": null,
                "createdBy": "NULL",
                "createdOn": null,
                "lastUpdatedBy": "NULL",
                "lastUpdatedOn": null,
                "expiryOn": null,
                "createdOnDateForDisplay": null,
                "createdOnDateInDDMmYYYFormat": null,
                "formattedCreatedDateForDisplay": null,
                "formattedUpdatedDateForDisplay": null,
                "userSubTypeMasterId": 9,
                "userSubTypeMaster": "Research Associate Professor"
            },
            {
                "startIndex": 0,
                "noOfRowsToFetch": 0,
                "mapOfAdditinalParams": null,
                "createdBy": "NULL",
                "createdOn": null,
                "lastUpdatedBy": "NULL",
                "lastUpdatedOn": null,
                "expiryOn": null,
                "createdOnDateForDisplay": null,
                "createdOnDateInDDMmYYYFormat": null,
                "formattedCreatedDateForDisplay": null,
                "formattedUpdatedDateForDisplay": null,
                "userSubTypeMasterId": 10,
                "userSubTypeMaster": "Research Assistant Professor"
            },
            {
                "startIndex": 0,
                "noOfRowsToFetch": 0,
                "mapOfAdditinalParams": null,
                "createdBy": "NULL",
                "createdOn": null,
                "lastUpdatedBy": "NULL",
                "lastUpdatedOn": null,
                "expiryOn": null,
                "createdOnDateForDisplay": null,
                "createdOnDateInDDMmYYYFormat": null,
                "formattedCreatedDateForDisplay": null,
                "formattedUpdatedDateForDisplay": null,
                "userSubTypeMasterId": 11,
                "userSubTypeMaster": "Instructor"
            },
            {
                "startIndex": 0,
                "noOfRowsToFetch": 0,
                "mapOfAdditinalParams": null,
                "createdBy": "NULL",
                "createdOn": null,
                "lastUpdatedBy": "NULL",
                "lastUpdatedOn": null,
                "expiryOn": null,
                "createdOnDateForDisplay": null,
                "createdOnDateInDDMmYYYFormat": null,
                "formattedCreatedDateForDisplay": null,
                "formattedUpdatedDateForDisplay": null,
                "userSubTypeMasterId": 12,
                "userSubTypeMaster": "Clinical Professor"
            },
            {
                "startIndex": 0,
                "noOfRowsToFetch": 0,
                "mapOfAdditinalParams": null,
                "createdBy": "NULL",
                "createdOn": null,
                "lastUpdatedBy": "NULL",
                "lastUpdatedOn": null,
                "expiryOn": null,
                "createdOnDateForDisplay": null,
                "createdOnDateInDDMmYYYFormat": null,
                "formattedCreatedDateForDisplay": null,
                "formattedUpdatedDateForDisplay": null,
                "userSubTypeMasterId": 13,
                "userSubTypeMaster": "Clinical Associate Professor"
            },
            {
                "startIndex": 0,
                "noOfRowsToFetch": 0,
                "mapOfAdditinalParams": null,
                "createdBy": "NULL",
                "createdOn": null,
                "lastUpdatedBy": "NULL",
                "lastUpdatedOn": null,
                "expiryOn": null,
                "createdOnDateForDisplay": null,
                "createdOnDateInDDMmYYYFormat": null,
                "formattedCreatedDateForDisplay": null,
                "formattedUpdatedDateForDisplay": null,
                "userSubTypeMasterId": 14,
                "userSubTypeMaster": "Clinical Assistant Professor"
            },
            {
                "startIndex": 0,
                "noOfRowsToFetch": 0,
                "mapOfAdditinalParams": null,
                "createdBy": "NULL",
                "createdOn": null,
                "lastUpdatedBy": "NULL",
                "lastUpdatedOn": null,
                "expiryOn": null,
                "createdOnDateForDisplay": null,
                "createdOnDateInDDMmYYYFormat": null,
                "formattedCreatedDateForDisplay": null,
                "formattedUpdatedDateForDisplay": null,
                "userSubTypeMasterId": 15,
                "userSubTypeMaster": "Professor Emeritus"
            },
            {
                "startIndex": 0,
                "noOfRowsToFetch": 0,
                "mapOfAdditinalParams": null,
                "createdBy": "NULL",
                "createdOn": null,
                "lastUpdatedBy": "NULL",
                "lastUpdatedOn": null,
                "expiryOn": null,
                "createdOnDateForDisplay": null,
                "createdOnDateInDDMmYYYFormat": null,
                "formattedCreatedDateForDisplay": null,
                "formattedUpdatedDateForDisplay": null,
                "userSubTypeMasterId": 16,
                "userSubTypeMaster": "Associate Professor Emeritus"
            },
            {
                "startIndex": 0,
                "noOfRowsToFetch": 0,
                "mapOfAdditinalParams": null,
                "createdBy": "NULL",
                "createdOn": null,
                "lastUpdatedBy": "NULL",
                "lastUpdatedOn": null,
                "expiryOn": null,
                "createdOnDateForDisplay": null,
                "createdOnDateInDDMmYYYFormat": null,
                "formattedCreatedDateForDisplay": null,
                "formattedUpdatedDateForDisplay": null,
                "userSubTypeMasterId": 17,
                "userSubTypeMaster": "Assistant Professor Emeritus"
            },
            {
                "startIndex": 0,
                "noOfRowsToFetch": 0,
                "mapOfAdditinalParams": null,
                "createdBy": "NULL",
                "createdOn": null,
                "lastUpdatedBy": "NULL",
                "lastUpdatedOn": null,
                "expiryOn": null,
                "createdOnDateForDisplay": null,
                "createdOnDateInDDMmYYYFormat": null,
                "formattedCreatedDateForDisplay": null,
                "formattedUpdatedDateForDisplay": null,
                "userSubTypeMasterId": 18,
                "userSubTypeMaster": "Senior lecturer"
            },
            {
                "startIndex": 0,
                "noOfRowsToFetch": 0,
                "mapOfAdditinalParams": null,
                "createdBy": "NULL",
                "createdOn": null,
                "lastUpdatedBy": "NULL",
                "lastUpdatedOn": null,
                "expiryOn": null,
                "createdOnDateForDisplay": null,
                "createdOnDateInDDMmYYYFormat": null,
                "formattedCreatedDateForDisplay": null,
                "formattedUpdatedDateForDisplay": null,
                "userSubTypeMasterId": 19,
                "userSubTypeMaster": "Lecturer"
            },
            {
                "startIndex": 0,
                "noOfRowsToFetch": 0,
                "mapOfAdditinalParams": null,
                "createdBy": "NULL",
                "createdOn": null,
                "lastUpdatedBy": "NULL",
                "lastUpdatedOn": null,
                "expiryOn": null,
                "createdOnDateForDisplay": null,
                "createdOnDateInDDMmYYYFormat": null,
                "formattedCreatedDateForDisplay": null,
                "formattedUpdatedDateForDisplay": null,
                "userSubTypeMasterId": 20,
                "userSubTypeMaster": "Associate Professor"
            },
            {
                "startIndex": 0,
                "noOfRowsToFetch": 0,
                "mapOfAdditinalParams": null,
                "createdBy": "NULL",
                "createdOn": null,
                "lastUpdatedBy": "NULL",
                "lastUpdatedOn": null,
                "expiryOn": null,
                "createdOnDateForDisplay": null,
                "createdOnDateInDDMmYYYFormat": null,
                "formattedCreatedDateForDisplay": null,
                "formattedUpdatedDateForDisplay": null,
                "userSubTypeMasterId": 21,
                "userSubTypeMaster": "Senior Associate Professor"
            },
            {
                "startIndex": 0,
                "noOfRowsToFetch": 0,
                "mapOfAdditinalParams": null,
                "createdBy": "NULL",
                "createdOn": null,
                "lastUpdatedBy": "NULL",
                "lastUpdatedOn": null,
                "expiryOn": null,
                "createdOnDateForDisplay": null,
                "createdOnDateInDDMmYYYFormat": null,
                "formattedCreatedDateForDisplay": null,
                "formattedUpdatedDateForDisplay": null,
                "userSubTypeMasterId": 22,
                "userSubTypeMaster": "Teacher"
            },
            {
                "startIndex": 0,
                "noOfRowsToFetch": 0,
                "mapOfAdditinalParams": null,
                "createdBy": "NULL",
                "createdOn": null,
                "lastUpdatedBy": "NULL",
                "lastUpdatedOn": null,
                "expiryOn": null,
                "createdOnDateForDisplay": null,
                "createdOnDateInDDMmYYYFormat": null,
                "formattedCreatedDateForDisplay": null,
                "formattedUpdatedDateForDisplay": null,
                "userSubTypeMasterId": 23,
                "userSubTypeMaster": "Professorial fellow"
            },
            {
                "startIndex": 0,
                "noOfRowsToFetch": 0,
                "mapOfAdditinalParams": null,
                "createdBy": "NULL",
                "createdOn": null,
                "lastUpdatedBy": "NULL",
                "lastUpdatedOn": null,
                "expiryOn": null,
                "createdOnDateForDisplay": null,
                "createdOnDateInDDMmYYYFormat": null,
                "formattedCreatedDateForDisplay": null,
                "formattedUpdatedDateForDisplay": null,
                "userSubTypeMasterId": 24,
                "userSubTypeMaster": "Reader"
            }
        ]
    },
    "userSubType": {
        "startIndex": 0,
        "noOfRowsToFetch": 0,
        "mapOfAdditinalParams": null,
        "createdBy": "NULL",
        "createdOn": null,
        "lastUpdatedBy": "NULL",
        "lastUpdatedOn": null,
        "expiryOn": null,
        "createdOnDateForDisplay": null,
        "createdOnDateInDDMmYYYFormat": null,
        "formattedCreatedDateForDisplay": null,
        "formattedUpdatedDateForDisplay": null,
        "userSubTypeMasterId": 18,
        "userSubTypeMaster": "Senior lecturer"
    },
    "primaryCommunication": null,
    "userEducation": {
        "startIndex": 0,
        "noOfRowsToFetch": 0,
        "mapOfAdditinalParams": null,
        "createdBy": "ANONYMOUS",
        "createdOn": 1478284524000,
        "lastUpdatedBy": "ANONYMOUS",
        "lastUpdatedOn": 1478284525000,
        "expiryOn": null,
        "createdOnDateForDisplay": "11/04/2016",
        "createdOnDateInDDMmYYYFormat": null,
        "formattedCreatedDateForDisplay": null,
        "formattedUpdatedDateForDisplay": null,
        "userEducationId": 20,
        "userEducationDegreeCourse": "Master",
        "userEducationYear": null,
        "userEducationSemester": null,
        "userEducationCourseStatus": null,
        "userEducationSubject": "Computer Science",
        "userEducationSpecialization": null,
        "isEducationInstitutionUserDefined": null,
        "educationalInstitutionId": {
            "startIndex": 0,
            "noOfRowsToFetch": 0,
            "mapOfAdditinalParams": null,
            "createdBy": null,
            "createdOn": null,
            "lastUpdatedBy": null,
            "lastUpdatedOn": null,
            "expiryOn": null,
            "createdOnDateForDisplay": null,
            "createdOnDateInDDMmYYYFormat": null,
            "formattedCreatedDateForDisplay": null,
            "formattedUpdatedDateForDisplay": null,
            "educationalInstitutionId": 122,
            "educationalInstitutionCode": null,
            "educationalInstitutionFullName": null,
            "educationalInstitutionCampus": null,
            "countryFullName": null,
            "stateFullName": null,
            "cityFullName": null,
            "zipcodeValue": null,
            "eduInsUserDefined": true
        }
    },
    "userCredential": {
        "startIndex": 0,
        "noOfRowsToFetch": 0,
        "mapOfAdditinalParams": null,
        "createdBy": null,
        "createdOn": null,
        "lastUpdatedBy": null,
        "lastUpdatedOn": null,
        "expiryOn": null,
        "createdOnDateForDisplay": null,
        "createdOnDateInDDMmYYYFormat": null,
        "formattedCreatedDateForDisplay": null,
        "formattedUpdatedDateForDisplay": null,
        "userCredentialId": 43,
        "userId": null,
        "plainTextPassword": null,
        "plainTextOldPassword": null,
        "email": null
    },
    "privacySettings": {
        "startIndex": 0,
        "noOfRowsToFetch": 0,
        "mapOfAdditinalParams": null,
        "createdBy": "ANONYMOUS",
        "createdOn": 1478284524000,
        "lastUpdatedBy": null,
        "lastUpdatedOn": null,
        "expiryOn": null,
        "createdOnDateForDisplay": "11/04/2016",
        "createdOnDateInDDMmYYYFormat": null,
        "formattedCreatedDateForDisplay": null,
        "formattedUpdatedDateForDisplay": null,
        "privacySettingsId": 20,
        "profileVisibility": "EVERYONE",
        "showProfileVisitors": "ENABLED",
        "emailNotifications": "ENABLED"
    },
    "userRecommendedBooks": null,
    "pastEducations": null,
    "userAddresses": [{
            "startIndex": 0,
            "noOfRowsToFetch": 0,
            "mapOfAdditinalParams": null,
            "createdBy": "ANONYMOUS",
            "createdOn": 1478284524000,
            "lastUpdatedBy": null,
            "lastUpdatedOn": null,
            "expiryOn": null,
            "createdOnDateForDisplay": "11/04/2016",
            "createdOnDateInDDMmYYYFormat": null,
            "formattedCreatedDateForDisplay": null,
            "formattedUpdatedDateForDisplay": null,
            "userAddressId": 20,
            "userDetailsId": null,
            "addressLine1": null,
            "addressLine2": null,
            "country": "US",
            "state": "ALABAMA",
            "city": "Alabaster",
            "zipCode": "12345",
            "countryId": null,
            "countryTO": null,
            "stateTO": null,
            "cityTO": null
        }],
    "projectResearchExps": null,
    "userRecommendedCourses": null,
    "userAcceptedRecommendations": null,
    "userSkillsets": null,
    "userGroups": [{
            "groupId": 1,
            "groupName": "GROUP_INTERNET_USER",
            "groupDescription": "Group for normal Users logging into the system"
        }],
    "peopleWhoVisitedMyProfile": null,
    "topEvents": null,
    "topJobs": null,
    "mySuggestedFriends": null,
    "eventLogs": null
};
//# sourceMappingURL=viewProfile.js.map